// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Services
import { AuthGuardAdmin } from './services/auth-guard-admin.service';
import { AuthGuardLogin } from './services/auth-guard-login.service';
// Components
import { AccountComponent } from './account/account.component';
import { AdminComponent } from './admin/admin.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientDetailsComponent } from './clients/client-details/client-details.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { GuidelinesComponent } from './guidelines/guidelines.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { OrganizationDetailsComponent } from './organizations/organization-details/organization-details.component';
import { PdfComponent } from './pdf/pdf.component';
import { RecordsComponent } from './records/records.component';
import { RecordDetailsComponent } from './records/record-details/record-details.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SearchAlertComponent } from './search/search-alert/search-alert.component';
import { SearchComponent } from './search/search.component';
import { StakeholdersComponent } from './stakeholders/stakeholders.component';
import { StakeholderDetailsComponent } from './stakeholders/stakeholder-details/stakeholder-details.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { TeamComponent } from './team/team.component';
import { UserDetailsComponent } from './team/user-details/user-details.component';

const routes: Routes = [
  { path: '', component: SearchComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'reset/:token', component: ResetPasswordComponent },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuardLogin] },
  { path: 'search/alert/:id', component: SearchAlertComponent, canActivate: [AuthGuardLogin] },
  { path: 'stakeholders', component: StakeholdersComponent, canActivate: [AuthGuardLogin] },
  { path: 'stakeholder/:id', component: StakeholderDetailsComponent, canActivate: [AuthGuardLogin] },
  { path: 'organizations', component: OrganizationsComponent, canActivate: [AuthGuardLogin] },
  { path: 'organization/:id', component: OrganizationDetailsComponent, canActivate: [AuthGuardLogin] },
  { path: 'clients', component: ClientsComponent, canActivate: [AuthGuardLogin] },
  { path: 'client/:id', component: ClientDetailsComponent, canActivate: [AuthGuardLogin] },
  { path: 'team', component: TeamComponent, canActivate: [AuthGuardLogin] },
  { path: 'user/:id', component: UserDetailsComponent, canActivate: [AuthGuardLogin] },
  { path: 'track-record', component: RecordsComponent, canActivate: [AuthGuardLogin] },
  { path: 'record/:id', component: RecordDetailsComponent, canActivate: [AuthGuardLogin] },
  { path: 'statistics', component: StatisticsComponent, canActivate: [AuthGuardLogin] },
  { path: 'pdf', component: PdfComponent, canActivate: [AuthGuardLogin] },
  { path: 'documents', component: GuidelinesComponent, canActivate: [AuthGuardLogin] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuardAdmin] },
  { path: 'feedback', component: FeedbackComponent, canActivate: [AuthGuardLogin] },
  { path: 'notifications', component: NotificationsComponent, canActivate: [AuthGuardLogin] },
  { path: 'account', component: AccountComponent, canActivate: [AuthGuardLogin] },
  { path: 'notfound', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule {}
